/**
 * @file tableAnnotatorRoutes.jsx
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Jan 25, 2026 17:28
 */
import { lazy } from 'react';
import Loader from './Loader';

const TableAnnotator = Loader(
    lazy(() => import('src/content/TableAnnotator/TableAnnotatorContainer'))
);

const GeneratedAnnotations = Loader(
    lazy(() => import('src/content/TableAnnotator/GeneratedAnnotations/GeneratedAnnotationsContainer'))
);

const tableAnnotatorRoutes = [
    {
        path: ':annotatorId/:tableId',
        element: <TableAnnotator />
    },
    {
        path: 'generatedAnnotations/:genBatchId',
        element: <GeneratedAnnotations />
    },
];

export default tableAnnotatorRoutes;